import semver from 'semver';

/**
 * Polyfill for lodash get.
 *
 * @param obj
 * @param path
 * @param def
 * @module utils
 */
export const get = function(obj, path, def) {
    const fullPath = path
        .replace(/\[/g, '.')
        .replace(/]/g, '')
        .split('.')
        .filter(Boolean);

    return fullPath.every(function (step) {
        return !(step && (obj = obj[step]) === undefined);
    }) ? obj : def;
};

/**
 * setTimeout wrapped in a Promise
 * @param {number} n number of milliseconds to wait
 * @returns {Promise}
 */
export const sleep = n => new Promise(resolve => setTimeout(resolve, n));

/**
 *
 * @param {string} version application version (semver)
 * @param {object} range
 * @param {string} range.min minimal version ex. '2.0.0', '2'
 * @param {string} range.max maximal version ex. '8.5.0'
 * @returns {boolean}
 */
export const validateVersion = function validateVersion(version, range) {
    const { min, max } = range;
    const coerceVersion = semver.coerce(version);
    const validVersion = semver.valid(coerceVersion);
    const validRange = semver.validRange(`${min || '*'} - ${max || '*'}`);
    return semver.satisfies(validVersion, validRange);
};

/**
 * Check if is the homepage or not
 *
 * @type {Function}
 *
 * @returns {boolean}
 */
export const isHomePage = function isHomePage() {
    return (window.WH && window.WH.sportsbook && window.WH.sportsbook.sport) === 'homepage';
};

/**
 * Check if the user agent has appended any of the passed deviceIds
 *
 * @param {string} currentUserAgent
 * @param {object} deviceIds
 * @returns {boolean}
 */

export const isUserAgentWithDeviceId = function isUserAgentWithDeviceId(currentUserAgent, deviceIds = {}) {
    if (!currentUserAgent) return false;

    return Object.values(deviceIds).some((deviceId) => {
        if (currentUserAgent.search(deviceId) !== -1) {
            return true;
        }
    });
};
